<ng-container *ngIf="directionIcon" [ngSwitch]="type">
    <i
        *ngSwitchCase="DATA_TYPE.NUMBER"
        [class]="'la la-sort-numeric-' + directionIcon"
        aria-hidden="true"
    ></i>
    <i
        *ngSwitchCase="DATA_TYPE.CURRENCY"
        [class]="'la la-sort-numeric-' + directionIcon"
        aria-hidden="true"
    ></i>
    <i
        *ngSwitchCase="DATA_TYPE.PERCENT"
        [class]="'la la-sort-numeric-' + directionIcon"
        aria-hidden="true"
    ></i>
    <i
        *ngSwitchCase="DATA_TYPE.BOOLEAN"
        [class]="'la la-sort-amount-' + directionIcon"
        aria-hidden="true"
    ></i>
    <i *ngSwitchCase="DATA_TYPE.STARS" [class]="'la la-sort-amount-' + directionIcon" aria-hidden="true"></i>
    <i *ngSwitchDefault [class]="'la la-sort-alpha-' + directionIcon" aria-hidden="true"></i>
</ng-container>
